(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pre-order-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-preorder-popup]');
  if (!root) return;
  var nativeFetch = (window.fetch && window.fetch.bind(window)) || null;

  var PREORDER_TAG = (root.dataset.preorderTag || 'preorder').toLowerCase();
  var MATCH_ALL = PREORDER_TAG === '*'; // set tag to "*" to trigger on every product (testing)
  var SUPPRESS_DRAWER = root.dataset.suppressDrawer === 'true';
  var CONFIRM_ADD = root.dataset.confirmAdd === 'true';

  var dialogEl = root.querySelector('[data-preorder-dialog]');
  var mediaEl = root.querySelector('[data-preorder-media]');
  var imageEl = root.querySelector('[data-preorder-image]');
  var cardEl = root.querySelector('[data-preorder-card]');
  var thumbEl = root.querySelector('[data-preorder-thumb]');
  var titleEl = root.querySelector('[data-preorder-product-title]');
  var variantEl = root.querySelector('[data-preorder-variant]');
  var priceEl = root.querySelector('[data-preorder-price]');
  var messageEl = root.querySelector('[data-preorder-message]');
  var cancelBtn = root.querySelector('[data-preorder-cancel]');
  var messageTemplate = messageEl ? messageEl.innerHTML : '';

  var currentLineKey = null;
  var pendingForm = null;
  var bypassOnce = false;
  var skipInspectUntil = 0;

  function open() { root.hidden = false; document.body.style.overflow = 'hidden'; }
  function close() { root.hidden = true; document.body.style.overflow = ''; pendingForm = null; }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  root.querySelectorAll('[data-preorder-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  var keepBtn = root.querySelector('[data-preorder-keep]');
  if (keepBtn) {
    keepBtn.addEventListener('click', function () {
      if (CONFIRM_ADD && pendingForm) { performAdd(pendingForm); return; }
      close();
    });
  }

  function cartDrawerEl() {
    var sel = (root.dataset.cartDrawerSelector || '').trim() ||
      '[id^="CartDrawer"], cart-drawer, #CartDrawer, .cart-drawer, [id*="cart-drawer" i]';
    return document.querySelector(sel);
  }

  if (cancelBtn) {
    cancelBtn.addEventListener('click', close);
  }

  function showFor(item) {
    currentLineKey = item.key || null;
    var title = item.product_title || item.title || '';
    var img = item.image || (item.featured_image && item.featured_image.url) || '';

    if (titleEl) titleEl.textContent = title;
    if (variantEl) {
      var v = item.variant_title;
      variantEl.textContent = (v && v !== 'Default Title') ? v : '';
    }
    if (priceEl) priceEl.textContent = (item.price != null) ? money(item.price) : '';
    if (thumbEl) thumbEl.style.backgroundImage = img ? 'url("' + img + '")' : '';
    if (cardEl) cardEl.hidden = false;

    if (mediaEl && imageEl) {
      if (img) {
        imageEl.src = img; imageEl.hidden = false; mediaEl.hidden = false;
        if (dialogEl) dialogEl.classList.remove('preorder-popup__dialog--no-media');
      } else {
        imageEl.hidden = true; mediaEl.hidden = true;
        if (dialogEl) dialogEl.classList.add('preorder-popup__dialog--no-media');
      }
    }

    if (messageEl) {
      messageEl.innerHTML = messageTemplate.replace(/\[product\]/g, '<strong>' + escapeHtml(title) + '</strong>');
    }

    if (SUPPRESS_DRAWER) keepDrawerClosed();
    open();
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('cart-drawer') || cartDrawerEl();
    if (!drawer) return;
    if (typeof drawer.close === 'function') { try { drawer.close(); } catch (e) {} }
    ['active', 'animate', 'is-open', 'open', 'is-active', 'drawer--active', 'js-drawer-open'].forEach(function (c) {
      if (drawer.classList) drawer.classList.remove(c);
    });
    ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'js-drawer-open', 'cart-drawer-open', 'no-scroll', 'scroll-lock'].forEach(function (c) {
      document.body.classList.remove(c);
      document.documentElement.classList.remove(c);
    });
  }

  // The theme opens the drawer a beat after add; close it across a short window.
  function keepDrawerClosed() {
    closeCartDrawer();
    [30, 120, 260, 450].forEach(function (t) { setTimeout(closeCartDrawer, t); });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer') || cartDrawerEl();
    if (!drawer) return;
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    ['active', 'is-open', 'open'].forEach(function (c) { if (drawer.classList) drawer.classList.add(c); });
    document.body.classList.add('overflow-hidden');
  }

  // Confirm-before-add: re-fire the add we blocked, letting the theme add the
  // item AND open its own drawer. bypassOnce lets this one submit through;
  // skipInspectUntil stops the post-add hook re-opening the popup.
  function performAdd(form) {
    if (!form) { close(); return; }
    skipInspectUntil = Date.now() + 2500;
    bypassOnce = true;
    close();
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function showForVariant(variantId) {
    var d = (window.PreorderData && window.PreorderData[variantId]) || {};
    showFor({
      key: null,
      product_title: d.t || '',
      variant_title: d.v || '',
      price: (d.p != null ? d.p : null),
      image: d.img || ''
    });
  }

  function isPreorderVariant(variantId) {
    var map = window.PreorderVariants;
    return !!(map && map[variantId] === true);
  }

  function inspect(items) {
    if (Date.now() < skipInspectUntil) return; // just confirmed — don't re-open popup
    items.forEach(function (item) {
      // Decision from the live-stock map; display straight from the added line
      // item so the exact variant is always shown. (Tag field = * force-shows.)
      if (!MATCH_ALL && !isPreorderVariant(item.id)) return;
      showFor(item);
    });
  }

  function normalize(data) {
    if (!data) return [];
    if (Array.isArray(data.items)) return data.items;
    if (data.id) return [data];
    return [];
  }

  // Confirm-before-add: block the theme's add for pre-order items, show the popup first.
  if (CONFIRM_ADD) {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      if (bypassOnce) { bypassOnce = false; return; } // confirmed add — let it through
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;
      if (!isPreorderVariant(idInput.value)) return; // normal items add as usual
      e.preventDefault();
      e.stopImmediatePropagation();
      pendingForm = form;
      showForVariant(idInput.value);
    }, true);
  }

  var isAddUrl = function (u) { return /\/cart\/add(\.js)?(\?|$)/.test(u || ''); };

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      return origFetch.apply(this, arguments).then(function (res) {
        if (isAddUrl(urlStr) && res.ok) {
          res.clone().json().then(function (d) { inspect(normalize(d)); }).catch(function () {});
        }
        return res;
      });
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this._preUrl = url; return origOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (isAddUrl(xhr._preUrl)) {
      xhr.addEventListener('load', function () {
        try { inspect(normalize(JSON.parse(xhr.responseText))); } catch (e) {}
      });
    }
    return origSend.apply(this, arguments);
  };
})();

  } catch(e) { console.error(e); }
})();
})();
